import { bunja } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import { isAfter } from 'date-fns';
import { atom } from 'jotai';
import { createContext } from 'react';

import { userRegulationBunja } from '@flipster/features/src/shared/regulation';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import type { GnbPromotionItemFragment } from '@web/app/_layout/navigation/query.generated';

export const PromotionContext = createContext<GnbPromotionItemFragment | undefined>(undefined);
const PromotionScope = createScopeFromContext(PromotionContext);

export const promotionBunja = bunja(() => {
  const promotion = bunja.use(PromotionScope);
  const { isSpotOnlyAtom } = bunja.use(userRegulationBunja);
  const store = bunja.use(JotaiStoreScope);
  const dateAtom = atom<Date>(new Date());

  const promotionAtom = atom((get) => {
    if (!promotion) return null;
    if (get(isSpotOnlyAtom)) return null;
    if (isAfter(get(dateAtom), promotion.endDate)) return null;
    return promotion;
  });

  bunja.effect(() => {
    const timer = setInterval(() => {
      store.set(dateAtom, new Date());
    }, 10 * 1000);
    return () => {
      clearInterval(timer);
    };
  });

  return { promotionAtom };
});
